// extracted by mini-css-extract-plugin
export default {"base":"vp_g09Tm","image":"vp_Boc2z","placeholder":"vp_rd0ip","badge":"vp_y4pGz","action":"vp_h4Es8","text":"vp_ZrN1J","title":"vp_F_ucL","meta":"vp_ZDrbs","link":"vp_ShoEn"};